import React from "react";
const Privacy = () => {
  return (
    <>
      <div className="privacy-policy terms-and-condition container">
        <h1>Privacy Policy</h1>
        <div className="mt-3 mb-5">
          <p>
            Bizooka (“we,” “our,” “us”) respects your privacy and is committed
            to protecting your personal data. This Privacy Policy outlines how
            we collect, use, and safeguard your information when you use our
            platform.
          </p>
          <br />
          <h3>1. Information We Collect</h3>
          <p className="my-2 ms-3">
            We collect the following types of information:
          </p>
          <ul className="ms-4">
            <li className="list-style-dot">
              <span className="fw-semibold">User Information: </span>First Name,
              Last Name, Email Address, Profile Information, Preferences, and
              Location Data.
            </li>
            <li className="list-style-dot">
              <span className="fw-semibold">Business Information: </span>{" "}
              Business Name, Description, Location, Contact Details, and
              Verification Documents.
            </li>
            <li className="list-style-dot">
              <span className="fw-semibold">Usage Data: </span> Device
              information, IP address, browser type, and analytics data
              collected via Google Analytics, App Store, and Play Store.
            </li>
            <li className="list-style-dot">
              <span className="fw-semibold">Cookies and Tracking: </span> We use
              cookies and similar tracking technologies to improve user
              experience and app performance
            </li>
          </ul>
          <br />
          <h3>2. How We Use Your Information </h3>
          <p className="my-2 ms-3">
            We collect the following types of information:
          </p>
          <ul className="ms-4">
            <li className="list-style-dot">
              Personalize your experience by providing relevant business
              recommendations.
            </li>
            <li className="list-style-dot">
              Verify business authenticity and maintain platform security.
            </li>
            <li className="list-style-dot">
              Improve app functionality and enhance user engagement through
              analytics.
            </li>
            <li className="list-style-dot">
              Communicate with users regarding account updates, security
              notifications, and promotional offers.
            </li>
          </ul>

          <br />
          <h3>3. Data Sharing & Third-Party Access</h3>
          <ul className="ms-4">
            <li className="list-style-dot">
              We do not sell, rent, or share user data with third parties for
              marketing purposes.
            </li>
            <li className="list-style-dot">
              We may share data with third-party service providers necessary for
              app functionality, including Google Analytics, App Store, and Play
              Store.
            </li>
            <li className="list-style-dot">
              Law enforcement agencies may be granted access to data if required
              by legal obligations.
            </li>
          </ul>
          <br />
          <h3>4. Account Security & Data Protection </h3>
          <ul className="ms-4 mt-3">
            <li className="list-style-dot">
              We implement industry-standard security measures to protect your
              data from unauthorized access, alteration, or disclosure
            </li>
            <li className="list-style-dot">
              However, we cannot guarantee absolute security. Users are
              responsible for safeguarding their login credentials
            </li>
          </ul>
          <br />
          <h3>5. User Rights & Data Retention </h3>
          <ul className="ms-4 mt-3">
            <li className="list-style-dot">
              Users may update, modify, or delete their profile information at
              any time.
            </li>
            <li className="list-style-dot">
              Businesses may edit their listings and request verification
              reviews.
            </li>
            <li className="list-style-dot">
              We retain user data only as long as necessary for the purposes
              stated in this Privacy Policy.
            </li>
          </ul>
          <br />
          <h3>6. Changes to Privacy Policy </h3>
          <ul className="ms-4 mt-3">
            <li className="list-style-dot">
              We reserve the right to update this Privacy Policy at any time. Changes will be posted within the app, and significant changes will be communicated via email.
            </li>
            <li className="list-style-dot">
              Continued use of the app after changes indicates acceptance of the updated policy.
            </li>
          </ul>
          <br />
          <h3>7. Children`s Privacy</h3>
          <ul className="ms-4 mt-3">
            <li className="list-style-dot">
              Our services are not intended for children under the age of 13. We do not knowingly collect personal information from minors
            </li>
          </ul>
          <br />
          <h3>8. Changes to Terms</h3>
          <ul className="ms-4 mt-3">
            <li className="list-style-dot">
              We reserve the right to update or modify these Terms at any time.
              Continued use of the app signifies acceptance of the updated
              terms.
            </li>
            <li className="list-style-dot">
              Users will be notified of significant changes via email or app
              notifications
            </li>
          </ul>
          <br />
          <h3>9. Governing Law & Contact Information </h3>
          <ul className="ms-4 mt-3">
            <li className="list-style-dot">
              This Privacy Policy is governed by the laws of the United States.
            </li>
            <li className="list-style-dot">
              For any privacy-related inquiries, contact us at info@bizooka.co.
            </li>
          </ul>
          <br />
        </div>
      </div>
    </>
  );
};
export { Privacy };
